// extracted by css-extract-rspack-plugin
export default {"toolbar":"toolbar-wASJl7","regular":"regular-aSD2ka","dense":"dense-eJrRPr"};